import { createAction } from '@ngrx/store';

export const initialization = createAction(
  '[System] Initialization'
);

export const refresh = createAction(
  '[System] Refresh'
);
